import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { OrgLlmProviderTemplatesResponse } from "../OrgLlmProviderRecord";

import { orgQueryKeys } from "./orgQueryKeys";

const FIFTEEN_MINUTES_MS = 15 * 60 * 1000;

/**
 * What the org's model settings pre-fill: the Roboto-managed models the
 * caller may put on the org, and the connection form defaults per kind.
 */
export function useOrgLlmProviderTemplates(orgId: string) {
  const { orgService } = useDomainServices();

  return useQuery<OrgLlmProviderTemplatesResponse, Error>({
    queryKey: orgQueryKeys.llmProviderTemplates(orgId),
    queryFn: ({ signal }) =>
      orgService.getOrgLlmProviderTemplates(orgId, { abortSignal: signal }),
    staleTime: FIFTEEN_MINUTES_MS,
  });
}
